import {GET_ALL_APPLIED_PROPERTIES} from "../actions/types";

const initialState = {
    appliedProperty: {
      docs: [],
      totalDocs: 0,
      limit: 0,
      page: 0,
      totalPages: 0,
      pagingCounter: 0,
      hasPrevPage: false,
      hasNextPage: false,
      prevPage: null,
      nextPage: null,
    },
    loading: true,
    // propertyData: {},
  };

  const getAppliedPropertiesReducer=(state=initialState,{type,payload})=>{
    switch(type){
        case GET_ALL_APPLIED_PROPERTIES:
            return {
                ...state,
                appliedProperty:payload,
                loading:false,
            };
        default:
            return state;
    }
  }

  export default getAppliedPropertiesReducer;